import gbFlag from './flags/gb.svg';
import ruFlag from './flags/ru.svg';
import { AppLocale } from './locales';

/**
 * Флаг рядом с названием языка. SVG-файлом, а не эмодзи: Chrome на Windows рисует эмодзи-флаги
 * двумя буквами («RU», «GB»). Английскому — британский флаг: язык, а не страна, выбор условный.
 */
export const LOCALE_FLAGS: Record<AppLocale, string> = {
  ru: ruFlag,
  en: gbFlag,
};
